import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().email('msg_error_invalid_email_format').required('msg_email_required'),
  phone: Yup.string()
    .trim()
    .matches(/^[0-9]+$/, 'msg_error_invalid_phone')
    .max(15, 'msg_error_invalid_phone'),
});
